import React from "react"

export default () => {
  return (
    <div>
      <h3>Below is the HTML Cheatsheet:</h3>
      <p>
        You can use this page as a reference for when you need to lookup a
        certain HTML tag.
      </p>
      <table className="plain-table">
        <thead>
          <tr>
            <th style={{ width: 100 }}>Tag</th>
            <th style={{ width: 100 }}>Name</th>
            <th style={{ width: "auto" }}>Code</th>
            <th style={{ width: "auto" }}>View</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td data-label="Tag">{`<!-- -->`}</td>
            <td data-label="Name">Comment</td>
            <td data-label="Code">
              You can’t see
              {` <!--This -->`}
            </td>
            <td data-label="View">You can’t see </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<a>`}</td>
            <td data-label="Name">Anchor</td>
            <td data-label="Code">
              {`<a href="http://www.millionairemillennial.me/">Visit Our Site</a>`}
            </td>
            <td data-label="View">
              <a id="unstyled" href="http://www.millionairemillennial.me/">
                Visit Our Site
              </a>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<b>`}</td>
            <td data-label="Name">Bold</td>
            <td data-label="Code">{`<b>Example</b>`}</td>
            <td data-label="View">
              <b>Example</b>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<body>`}</td>
            <td data-label="Name">Body of Page</td>
            <td data-label="Code">{`<body>This is the body</body>`}</td>
            <td data-label="View">
              <div>This is the body</div>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<br>`}</td>
            <td data-label="Name">Line Break</td>
            <td data-label="Code">{`This is what <br/> a line break looks like!`}</td>
            <td data-label="View">
              This is what
              <br />a link break looks like!
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<button>`}</td>
            <td data-label="Name">Button</td>
            <td data-label="Code">{`<button>This is clickable!</button>`}</td>
            <td data-label="View">
              <button id="unstyled">This is clickable!</button>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<center>`}</td>
            <td data-label="Name">Center</td>
            <td data-label="Code">{`<center>This will be centered in the middle</center>`}</td>
            <td data-label="View">
              <center>This will be centered in the middle</center>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<div>`}</td>
            <td data-label="Name">Divider</td>
            <td data-label="Code">{`<div>This is a div</div><div>So is this...</div>`}</td>
            <td data-label="View">
              <div>This is a div</div>
              <div>So is this...</div>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<form>`}</td>
            <td data-label="Name">Form</td>
            <td data-label="Code">{`<form action="mailto:support@millionairemillennial.me
                    ">
                    Name: <input name="Name" value=""
                    size="10"><br>
                    Email: <input name="Email" value=""
                    size="10"><br>
                    <button type="submit">
                    </form>
                    `}</td>
            <td data-label="View">
              <form action="mailto:support@millionairemillennial.me">
                Name: <input readOnly name="Name" value="" size="10" />
                <br />
                Email: <input readOnly name="Email" value="" size="10" />
                <br />
                <button id="unstyled" type="submit">
                  Submit
                </button>
              </form>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">
              {`<h1>`}
              <br />
              {`<h2>`}
              <br />
              {`<h3>`}
              <br />
              {`<h4>`}
              <br />
              {`<h5>`}
              <br />
              {`<h6>`}
              <br />
            </td>
            <td data-label="Name">
              heading 1 <br />
              heading 2 <br />
              heading 3 <br />
              heading 4 <br />
              heading 5 <br />
              heading 6
            </td>
            <td data-label="Code">
              {`<h1>Heading 1 Example</h1>`}
              <br />
              {`<h1>Heading 2 Example</h1>`}
              <br />
              {`<h1>Heading 3 Example</h1>`}
              <br />
              {`<h1>Heading 4 Example</h1>`}
              <br />
              {`<h1>Heading 5 Example</h1>`}
              <br />
              {`<h1>Heading 6 Example</h1>`}
              <br />
            </td>
            <td data-label="View">
              <h1>Heading 1 Example</h1>
              <h2>Heading 2 Example</h2>
              <h3>Heading 3 Example</h3>
              <h4>Heading 4 Example</h4>
              <h5>Heading 5 Example</h5>
              <h6>Heading 6 Example</h6>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<head>`}</td>
            <td data-label="Name">Head of Document</td>
            <td data-label="Code">
              {`<head>This has info about the page and won't be seen</head>`}
            </td>
            <td data-label="View"> </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<hr>`}</td>
            <td data-label="Name">Horizontal Rule</td>
            <td data-label="Code">
              {`It's a line break...<hr/>...but with a line!`}
            </td>
            <td data-label="View">
              {" "}
              It's a line break...
              <hr />
              ...but with a line!
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<i>`}</td>
            <td data-label="Name">Italics</td>
            <td data-label="Code">{`<i>I'm italicized</i>`}</td>
            <td data-label="View">
              <i>I'm italicized</i>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<img>`}</td>
            <td data-label="Name">Image</td>
            <td data-label="Code">{`<img
                src="https://via.placeholder.com/100"
                width="100"
                height="100"
                alt="text describing the image"
              />`}</td>
            <td data-label="View">
              <img
                src="https://via.placeholder.com/100"
                width="100"
                height="100"
                alt="text describing the image"
              />
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<input>`}</td>
            <td data-label="Name">Input</td>
            <td data-label="Code">{`<input type="text" maxlength="7" />`}</td>
            <td data-label="View">
              <input type="text" maxLength="7" style={{maxWidth:'100%'}} />
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<li>`}</td>
            <td data-label="Name">List Item</td>
            <td data-label="Code">
              {` <ol type="1"> `}
              <br />
              {` <li>List item 1</li> `}
              <br />
              {` <li>List item 2</li> `}
              <br />
              {` <li>List item 3</li> `}
              <br />
              {` <li>List item 4</li> `}
              <br />
              {` </ol> `}
            </td>
            <td data-label="View">
              <ol type="1">
                <li>List item 1</li>
                <li>List item 2</li>
                <li>List item 3</li>
                <li>List item 4</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<link>`}</td>
            <td data-label="Name">Link to external assets</td>
            <td data-label="Code">{`<head>
                <link rel="stylesheet" type="text/css"
                href="style.css" />
                </head>`}</td>
            <td data-label="View"></td>
          </tr>
          <tr>
            <td data-label="Tag">{`<meta>`}</td>
            <td data-label="Name">Meta Descriptions</td>
            <td data-label="Code">{`<meta name="Description"
                content="Description of your site">
                <meta name="keywords"
                content="keywords describing your site">`}</td>
            <td data-label="View"></td>
          </tr>
          <tr>
            <td data-label="Tag">{`<ol>`}</td>
            <td data-label="Name">Ordered List</td>
            <td data-label="Code">
              {` <ol type="A"> `}
              <br />
              {` <li>List item 1</li> `}
              <br />
              {` <li>List item 2</li> `}
              <br />
              {` <li>List item 3</li> `}
              <br />
              {` <li>List item 4</li> `}
              <br />
              {` </ol> `}
            </td>
            <td data-label="View">
              <ol type="A">
                <li>List item 1</li>
                <li>List item 2</li>
                <li>List item 3</li>
                <li>List item 4</li>
              </ol>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<p>`}</td>
            <td data-label="Name">Paragraph</td>
            <td data-label="Code">{`<p>
                A nice paragraph here...
                </p>`}</td>
            <td data-label="View">
              <p>A nice paragraph here...</p>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<strike>`}</td>
            <td data-label="Name">Strikethrough</td>
            <td data-label="Code">{`<strike>Forget This</strike> `}</td>
            <td data-label="View">
              <strike>Forget This</strike>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<style>`}</td>
            <td data-label="Name">CSS Style Tag</td>
            <td data-label="Code">{`<style>h4 {color:red;}</style><h4>I'm red!</h4> `}</td>
            <td data-label="View">
              <h4 style={{ color: "red" }}>I'm red!</h4>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<table>`}</td>
            <td data-label="Name">Table</td>
            <td data-label="Code">
              {`<table border="4" cellpadding="2" cellspacing="2" width="100%">`}
              <br />
              {`<tbody>`}
              <br />
              {`<tr>`}
              <br />
              {`<td>Column 1</td>`}
              <br />
              {`<td>Column 2</td>`}
              <br />
              {` </tr>`}
              <br />
              {`</tbody>`}
              <br />
              {`</table>`}
              <br />
            </td>
            <td data-label="View">
              <table border="4" cellPadding="2" cellSpacing="2" width="100%">
                <tbody>
                  <tr>
                    <td>Column 1</td>
                    <td>Column 2</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<tr>`}</td>
            <td data-label="Name">Table Row</td>
            <td data-label="Code">
              {`<table border="4" cellpadding="2" cellspacing="2" width="100%">`}
              <br />
              {`<tbody>`}
              <br />
              {`<tr>`}
              <br />
              {`<td>Column 1</td>`}
              <br />
              {`<td>Column 2</td>`}
              <br />
              {` </tr>`}
              <br />
              {`</tbody>`}
              <br />
              {`</table>`}
              <br />
            </td>
            <td data-label="View">
              <table border="4" cellPadding="2" cellSpacing="2" width="100%">
                <tbody>
                  <tr>
                    <td>Column 1</td>
                    <td>Column 2</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<td>`}</td>
            <td data-label="Name">Table Cell</td>
            <td data-label="Code">
              {`<table border="4" cellpadding="2" cellspacing="2" width="100%">`}
              <br />
              {`<tbody>`}
              <br />
              {`<tr>`}
              <br />
              {`<td>Column 1</td>`}
              <br />
              {`<td>Column 2</td>`}
              <br />
              {` </tr>`}
              <br />
              {`</tbody>`}
              <br />
              {`</table>`}
              <br />
            </td>
            <td data-label="View">
              <table border="4" cellPadding="2" cellSpacing="2" width="100%">
                <tbody>
                  <tr>
                    <td>Column 1</td>
                    <td>Column 2</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<title>`}</td>
            <td data-label="Name">Title to the page</td>
            <td data-label="Code">{`<title>
                This will be the title of the page (viewable in the tab)
                </title>`}</td>
            <td data-label="View"></td>
          </tr>
          <tr>
            <td data-label="Tag">{`<u>`}</td>
            <td data-label="Name">Underline</td>
            <td data-label="Code">{`<u>This is underlined!
                </u>`}</td>
            <td data-label="View">
              <u>This is underlined!</u>
            </td>
          </tr>
          <tr>
            <td data-label="Tag">{`<ul>`}</td>
            <td data-label="Name">Unordered List</td>
            <td data-label="Code">
              {" "}
              {` <ul> `}
              <br />
              {` <li>List item 1</li> `}
              <br />
              {` <li>List item 2</li> `}
              <br />
              {` <li>List item 3</li> `}
              <br />
              {` <li>List item 4</li> `}
              <br />
              {` </ul> `}
            </td>
            <td data-label="View">
              <ul id="unstyled">
                <li>List item 1</li>
                <li>List item 2</li>
                <li>List item 3</li>
                <li>List item 4</li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
